import { z } from 'zod';

import { emailStrategy } from '@autopass-web/mochi-utils';

import { AppStorage } from '../../utils/storage';

import type { ReceiptsTypeValue } from '../../configs/receipts';
import type { FormControlRef } from '../../hooks/use-bind-async-submit';
import type {
  B2bReceiptInfo,
  CarrierCitizenDigitalReceiptInfo,
  CarrierMemberReceiptInfo,
  CarrierMobileReceiptInfo,
  DonateReceiptInfo,
  PaymentCarrierReceiptInfo,
} from './receipt-types';
import type { RefObject } from 'react';
import type { Mode as FormMode } from 'react-hook-form';
export type {
  EmailFieldConfig,
  ReceiptTypeConfig,
} from '../../configs/methods';

export const emailSchema = z
  .string()
  .min(1, {
    message: '此欄位為必填',
  })
  .refine(emailStrategy, {
    message: '格式錯誤',
  });

export type ReceiptInfo =
  | B2bReceiptInfo
  | CarrierMemberReceiptInfo
  | CarrierMobileReceiptInfo
  | DonateReceiptInfo
  | PaymentCarrierReceiptInfo
  | CarrierCitizenDigitalReceiptInfo;

export type ReceiptCompProps<TProp extends object | void = void> =
  TProp extends object
    ? {
        controlRef: RefObject<FormControlRef<ReceiptInfo>>;
        // use the persistent storage if needed like sessionStorage / localStorage or
        storage?: ReceptStorage;
        formMode?: FormMode;
      } & TProp
    : {
        controlRef: RefObject<FormControlRef<ReceiptInfo>>;
        storage?: ReceptStorage;
        formMode?: FormMode;
      };

export type ReceiptFormControlRef = FormControlRef<ReceiptInfo>;

type Merge<A, B> = Omit<A, keyof B> & B;

type MergeAll<T extends object[]> = T extends [infer Head, ...infer Tail]
  ? Head extends object
    ? Tail extends object[]
      ? Merge<Head, MergeAll<Tail>>
      : Head
    : T
  : T;

type ReceiptStorageValue = Omit<
  MergeAll<
    [
      B2bReceiptInfo,
      CarrierMemberReceiptInfo,
      CarrierMobileReceiptInfo,
      DonateReceiptInfo,
      PaymentCarrierReceiptInfo,
      CarrierCitizenDigitalReceiptInfo,
    ]
  >,
  'type'
> & { type: ReceiptsTypeValue };

export const receiptStorage = new AppStorage<Partial<ReceiptStorageValue>>(
  'mochi-payment::receipt',
  'json',
  'local',
);

export type ReceptStorage =  AppStorage<Partial<ReceiptStorageValue>>;

export {
  B2bReceiptInfo,
  CarrierCitizenDigitalReceiptInfo,
  CarrierMemberReceiptInfo,
  CarrierMobileReceiptInfo,
  DonateReceiptInfo,
  PaymentCarrierReceiptInfo,
};
